<style media="screen" type="text/css">

.filter-dialog {
  height: 550px !important;
  border-radius: 20px;
}

.scrolable-box {
  min-height: 400px;
  max-height: 400px;
  overflow-y: scroll;
}

.deduction_amount .v-input__slot {
  min-height: 25px !important
}


</style>

<template>
  <div class="shipment-filter">
    <v-dialog
        v-model="dialog.flag"
        :scollable="false"
        class="filter-dialog"
        width="565"
    >
      <v-stepper v-model="step" class="elevation-0">
        <v-stepper-items>
          <v-stepper-content class="px-2 pt-0" step="1">
            <v-card>
              <p class="text-right pr-3" style="!important">
                <v-icon color="#8F8F8F" small
                        @click="dialog.flag=false">
                  mdi-window-close
                </v-icon>
              </p>
              <v-card-text class="pa-0">
                <p class="page-title py-2 mb-0">{{ $lang.INITIATE_PAYOUT.toUpperCase() }}</p>
                <div class="agent-list-box px-7 scrolable-box">
                  <v-checkbox v-model="select_all" @change="selectAll">
                    <template v-slot:label>
                      <div>
                        <p class="sub-title-text-dark">
                          {{ $lang.SELECT_ALL }}
                        </p>
                      </div>
                    </template>
                  </v-checkbox>

                  <v-text-field
                      v-model="search_query"
                      :label="$lang.SEARCH"
                      append-icon="mdi-magnify"
                      class="mb-2"
                      dense
                      hide-details
                      outlined
                      rounded
                      single-line
                      @keyup="getAgents"
                  ></v-text-field>

                  <v-checkbox
                      v-for="agent in agent_list"
                      :key="agent.id"
                      v-model="agent_id_list"
                      :label="agent.agent_name"
                      :value="agent"
                      class="mt-1 custome-checkbox"
                      hide-details>
                    <template v-slot:label>
                      <v-row class="mx-0">
                        <v-col class="py-0" cols="9" md="8">
                          <p class="sub-title-text-dark">
                            {{ agent.agent_name }}<small class="secondary-text fs-12">({{ agent.agent_type }})</small>
                          </p>
                          <p class="select-secondary-text">{{ agent.agent_phone_number }}</p>
                        </v-col>
                        <v-col class="py-0 text-right" cols="12" md="4">
                          <p class="sub-title-text-dark">
                            <v-icon color="black" small style="margin-top:-2px;margin-right:-4px">
                              mdi-currency-inr
                            </v-icon>
                            {{ agent.wallet_amount }}
                          </p>
                        </v-col>
                        <v-col class="py-0" cols="12" md="12">
                          <div>
                            <small class="sub-title-text-dark">{{ $lang.DEDUCTION_AMOUNT }}:</small>
                            <small v-if="!agent.is_edit" class="sub-title-text-dark">
                              <v-icon color="black" small style="margin-top:-2px;margin-right:-4px"> mdi-currency-inr
                              </v-icon>
                              {{ agent.deduction_amount }}</small>

                            <v-text-field
                                v-if="agent.is_edit"
                                v-model="agent.deduction_amount"
                                :maxlength="agent.wallet_amount.length"
                                :placeholder="$lang.AMOUNT"
                                :rules="$rules.amountRule"
                                class="d-inline-flex deduction_amount ml-2 text-center"
                                dense
                                hide-details
                                single-line
                                style="width:100px;height:40px"
                                @change="validateDeductionAmount(agent)"
                            ></v-text-field>
                          </div>
                          <div class="mb-3">
                            <p v-if="!agent.is_edit" class="sub-title-text-3 fs-14 my-0 mt-2 ">
                              {{ agent.deduction_reason }}
                            </p>
                            <v-text-field
                                v-if="agent.is_edit"
                                v-model="agent.deduction_reason"
                                :placeholder="$lang.DEDUCTION_REASON"
                                class="d-inline-flex deduction_amount"
                                dense
                                single-line
                                style="height:20px;width:100%"
                            ></v-text-field>
                          </div>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                      <div>
                      </div>
                    </template>
                    <template v-slot:append>
                      <v-icon small @click="agent.is_edit=!agent.is_edit">mdi-pencil</v-icon>
                    </template>
                  </v-checkbox>
                </div>
                <div class="text-center">
                  <v-btn :disabled="agent_id_list.length>0?false:true" :loading="btn_loading" class="mb-4"
                         color="primary"
                         @click="SendOTP">
                    <b>{{ $lang.INITIATE_PAYOUT }}</b>
                  </v-btn>
                </div>

              </v-card-text>
            </v-card>
          </v-stepper-content>
          <v-stepper-content class="pt-0" step="2">
            <p class="text-right pr-0" style="margin-top:0px !important">
              <v-icon color="#8F8F8F" small
                      @click="dialog.flag=false">
                mdi-window-close
              </v-icon>
            </p>
            <v-card-text class="flex-column mb-5 px-0">
              <!--  dialog title -->
              <p class="page-title text-center">{{ $lang.VERIFICATION.toUpperCase() }}</p>

              <div class="mt-8 text-center">
                <div class=" mt-2">
                  <!-- <p class="secodry-text-2 mb-1">{{$lang.OTP.toUpperCase()}}</p> -->
                  <p class="secodry-text-2 my-2">Enter the 6-digit code sent to {{ mobile }}</p>
                  <otp-block input-classes="small-input-block" @on-complete="getOtp"/>
                </div>
                <p class="mt-5">{{ otp }}</p>
                <!-- 	<p class="messge-text-green cursor-pointer text-left mt-2" @click="resendOtp">{{$lang.RESEND_TO}}{{dialog.item.mobile}}</p> -->
              </div>
            </v-card-text>
            <v-card-actions class="text-center pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="otp_value.length!=6?true:false" :loading="btn_loading" class="fw-bold ml-5"
                     color="primary"
                     width="90" @click="initiatePayout">
                {{ $lang.CONTINUE }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["dialog"],
  components: {
    OtpBlock: () => import('@/components/common-components/opt-input-box/OtpBlock.vue'),
  },
  data() {
    return {
      step: 1,
      agent_list: [],
      agent_id_list: [],
      select_all: false,
      search_query: "",
      btn_loading: false,
      otp_value: "",
      otp_token: "",
      mobile: "",
      otp: "",
    }
  },
  methods: {
    /* deduction amount validaton */
    validateDeductionAmount(agent) {
      // console.log("log.1", isNaN(parseFloat(agent.deduction_amount)))
      // console.log("log.2", agent.deduction_amount < 0)
      // console.log("log.3", parseFloat(agent.deduction_amount) >= parseFloat(agent.wallet_amount))
      if (isNaN(parseFloat(agent.deduction_amount)))
        agent.deduction_amount = 0
      if (agent.deduction_amount < 0)
        agent.deduction_amount = 0
      if (parseFloat(agent.deduction_amount) >= parseFloat(agent.wallet_amount))
        agent.deduction_amount = 0
      // if ((!isNaN(parseFloat(agent.deduction_amount)) || agent.deduction_amount >= 1 || agent.deduction_amount <= agent.wallet_amount))
      //   agent.deduction_amount = 0
    },
    /* request  otp */
    SendOTP() {
      const self = this
      self.btn_loading = true
      var form = new FormData();
      // form.append("agent_document",self.document)

      const successHandler = (response) => {
        if (response.data.success) {
          self.step = 2
          self.otp_token = response.headers["otp-token"]
          self.mobile = response.data.phone_number
          self.otp = response.data.otp
        }
      };
      const finallyHandler = () => {
        self.btn_loading = false
      };
      this.request_POST(self, self.$urls.SEND_OTP_TO_WAREHOUSE, form, successHandler, null, null, finallyHandler)

    },
    /* get  agent list */
    getAgents() {
      const self = this
      self.filter_agent_type = status
      let params = {
        is_payout_allowed: "Yes",
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.search_query,
      };

      self.table_loading = true;
      const successHandler = (response) => {
        self.agent_list = response.data.agent_list
        self.selectAll()

      };
      const finallyHandler = () => {
        self.table_loading = false
      };
      self.request_GET(self, self.$urls.AGENT_LIST_FOR_PAYOUT, params, successHandler, null, null, finallyHandler)
    },
    selectAll() {
      if (this.select_all == true)
        this.agent_id_list = this.agent_list
      else
        this.agent_id_list = []
    },
    getOtp(otp) {
      this.otp_value = otp
    },
    /* initiate Payouts for all users */
    initiatePayout() {
      const self = this
      this.btn_loading = true

      var header = {
        'token': sessionStorage.getItem("token"),
        'otp-token': this.otp_token,
      }

      let params = {
        'otp': this.otp_value,
        filter_agent_id_list: JSON.stringify(this.agent_id_list),
      };
      const successHandler = (response) => {
        if (response.data.success) {
          self.dialog.flag = false
          self.showSnakeBar("success", this.$messages.INITIATE_PAYOUT_SUCCESS_MSG)
          self.select_all = false
          self.$emit('update')
        }
      };
      const finallyHandler = () => {
        this.btn_loading = false
      };

      self.request_GET(self, self.$urls.INITIATE_PAYOUT, params, successHandler, header, null, finallyHandler)
    },

  }
}
</script>